import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=4d46d510&scoped=true&"
import script from "./Label.vue?vue&type=script&lang=ts&"
export * from "./Label.vue?vue&type=script&lang=ts&"
import style0 from "./Label.vue?vue&type=style&index=0&id=4d46d510&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46d510",
  null
  
)

export default component.exports